// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTagOutlinedSvg from "@fishx/icons-svg/es/asn/PTagOutlined";
import FishxIcon from '../components/FishxIcon';

var PTagOutlined = function PTagOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTagOutlinedSvg
  }));
};

PTagOutlined.displayName = 'PTagOutlined';
export default React.forwardRef(PTagOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTagOutlined.js
// module id = 3673
// module chunks = 0